<template>
  <div class="reservation-period">
    <!-- TITULO -->
    <div class="form--title">
      <PmwHeading size="paragraph-80" weight="weight-light">
        Período de reserva
      </PmwHeading>

      <PmwParagraph class="form--subtitle" size="paragraph-40">
        Período que a tarifa estará disponível para ser reservada.
      </PmwParagraph>
    </div>

    <!-- INPUT DE DATAS E HORAS DOS HORÁRIOS DEFINIDOS -->
    <div class="form--row">
      <PmwFormDatepicker
        v-model="fluctuationData.dataInicioReserva"
        label="Data inicial"
        placeholder="01/01/2023"
        size="small"
        class="form--input__datepicker form--input__time"
        @input="initalReservationPeriodHandler"
      />

      <PmwFormInput
        v-model="horarioInicioReserva"
        label="Horário de início"
        type="time"
        size="small"
        class="form--input__time"
        @blur="initalReservationPeriodHandler"
      />
    </div>

    <div class="form--row">
      <PmwFormDatepicker
        v-model="fluctuationData.dataFimReserva"
        label="Data final"
        placeholder="01/01/2024"
        size="small"
        class="form--input__datepicker form--input__time"
        @input="endReservationPeriodHandler"
      />

      <PmwFormInput
        v-model="horarioFimReserva"
        label="Horário de fim"
        type="time"
        size="small"
        class="form--input__time"
        @blur="endReservationPeriodHandler"
      />
    </div>

    <!-- CHECKBOX DE HORÁRIO RECORRENTE -->
    <div class="form--row">
      <InputCheckbox
        v-model="cumulativeFreeNights"
        :checked="cumulativeFreeNights"
        :infoIcon="true"
        :inputValue="true"
        tooltipMinWidth="500"
        label="Definir horário de ativação recorrente"
        infoText="O horário padrão é das 00:00 às 23:59. Se determinado período de horário, a tarifa só será exibida na faixa determinada. Ótima opção para tarifas especiais exibidas na madrugada. Esse campo não tem relação com o campo Horário a partir de / até."
        name="cumulativeFreeNights"
        class="form--input__select "
      />
    </div>

    <div v-if="cumulativeFreeNights" class="form--row">
      <PmwFormInput
        v-model="fluctuationData.horaInicioReserva"
        label="Horário de início"
        type="time"
        size="small"
        class="form--input__time"
      />

      <PmwFormInput
        v-model="fluctuationData.horaFimReserva"
        label="Horário de fim"
        type="time"
        size="small"
        class="form--input__time"
      />
    </div>
  </div>
</template>

<script>
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import PmwFormDatepicker from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormDatepicker'
import InputCheckbox from '@solucoes/components-lib-tmp/src/components/elements/InputCheckbox'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import { formatDate } from '@/helpers/date'
import {
  formatISO,
  setHours,
  setMinutes,
  setSeconds,
  setMilliseconds
} from 'date-fns'
export default {
  name: 'ReservationPeriod',
  components: {
    PmwHeading,
    PmwParagraph,
    InputCheckbox,
    PmwFormDatepicker,
    PmwFormInput
  },

  props: {
    fluctuationData: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      cumulativeFreeNights: false,
      horarioInicioReserva: null,
      horarioFimReserva: null
    }
  },

  watch: {
    cumulativeFreeNights(newValue) {
      /** Caso o campo não seja editado, ele definira os valores padrão */
      if (newValue === false) {
        this.fluctuationData.horaInicioReserva = '00:00'
        this.fluctuationData.horaFimReserva = '23:59'
      }
    }
  },

  created() {
    /** Se for edição */
    if (this.$route.params.rateId) {
      /** Ajuste de horários de reserva */
      if (this.fluctuationData.dataInicioReserva)
        this.horarioInicioReserva = formatDate(
          new Date(this.fluctuationData.dataInicioReserva),
          'HH:mm'
        )

      if (this.fluctuationData.dataFimReserva)
        this.horarioFimReserva = formatDate(
          new Date(this.fluctuationData.dataFimReserva),
          'HH:mm'
        )

      if (
        this.fluctuationData.horaInicioReserva === '00:00' &&
        this.fluctuationData.horaFimReserva === '23:59'
      ) {
        this.cumulativeFreeNights = false
      } else if (
        this.fluctuationData.horaInicioReserva ||
        this.fluctuationData.horaFimReserva
      ) {
        this.cumulativeFreeNights = true
      }
    }
  },

  methods: {
    initalReservationPeriodHandler(newVal) {
      if (!this.horarioInicioReserva) {
        this.horarioInicioReserva = '00:00'
      }

      if (newVal) {
        this.fluctuationData.dataInicioReserva = this.adjustDateTime(
          this.fluctuationData.dataInicioReserva,
          this.horarioInicioReserva
        ).slice(0, -6)
      } else {
        this.horarioInicioReserva = null
      }
    },

    endReservationPeriodHandler(newVal) {
      if (!this.horarioFimReserva) {
        this.horarioFimReserva = '23:59'
      }

      if (newVal) {
        this.fluctuationData.dataFimReserva = this.adjustDateTime(
          this.fluctuationData.dataFimReserva,
          this.horarioFimReserva
        )
      } else {
        this.horarioFimReserva = null
      }
    },

    adjustDateTime(date, time) {
      /** Extrair horas e minutos */
      const [newHours, newMinutes] = time.split(':')

      /** Configurar as novas horas e minutos na data */
      return formatISO(
        setMilliseconds(
          setSeconds(
            setMinutes(setHours(new Date(date), newHours), newMinutes),
            0
          ),
          0
        )
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  &--button {
    max-width: 240px;
    width: 240px;
  }

  &--subtitle {
    font-size: font-size('size-small');
    font-weight: font-weight('weight-normal');
    color: pmw-colors(grey-80);
    line-height: 21px;
  }

  &--input {
    &__time {
      /** Alterar cores novas do select */
      ::v-deep {
        .pmw-form-field--label {
          font-weight: font-weight('weight-medium');
        }
        .form-field--label-wrapper {
          line-height: 21px;
          margin-bottom: 3px;
        }
        .pmw-input {
          background: $white;
        }
        .pmw-input--clear {
          z-index: 0;
        }
        .pmw-input__focus {
          border-color: $pmw-blue;
        }

        .pmw-input--field {
          background: $pmw-white;

          &:focus {
            border-color: $pmw-blue;
          }
        }

        .pmw-input__disabled {
          input {
            background: pmw-colors('grey-20');
            color: $pmw-gray-darker;
          }
        }

        .pmw-custom-tooltip {
          line-height: 18px;
        }
      }
    }

    &__select {
      width: 435px;
      max-width: 435px;
      margin-top: 16px;

      &.error {
        ::v-deep {
          .pmw-select--button {
            border-bottom-color: pmw-colors('error-100');
            border-bottom-width: 2px;
          }
        }
      }
    }

    &__datepicker {
      ::v-deep {
        .pmw-input--field:focus {
          border-color: pmw-colors(blue-100);
        }

        .pmw-input--clear {
          color: pmw-colors(blue-100);
        }
      }
    }
  }

  &--row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 24px;
    margin-bottom: 32px;
  }

  &--title {
    margin-bottom: 24px;
    position: relative;
  }

  &--radio-fields {
    display: flex;

    ::v-deep {
      .pmw-input-radio input:checked ~ .pmw-input-radio--fake-radio:before {
        background-color: pmw-colors(blue-100);
      }

      .pmw-input-radio input:checked ~ .pmw-input-radio--fake-radio {
        border-color: pmw-colors(blue-100);
      }
    }

    &__input {
      margin-right: 6px;
    }

    &__info {
      margin-top: 1px;
      margin-right: 21px;
    }
  }
}
</style>
